import { Redirect } from "react-router"
import { myLazy } from "utils/myLazy"
import { GooglePageViewTypes } from "utils/googleAnalytics/googleAnalyticsPageViewEvent"

export const adminCompanyRoutes = [
  // client companies list
  {
    exact: true,
    path: "/admin/company/client/list",
    component: myLazy(() => import("../views/admin/companies/companyTable")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Lista de companii"
  },

  {
    exact: false,
    path: "/admin/company/client/form",
    component: myLazy(() => import("../views/admin/companies/companyForm")),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Formular companie"
  },
  //===================================================================
  // delivery address
  {
    exact: true,
    path: "/admin/company/delivery/list",
    component: myLazy(() => import("../views/admin/adreseDeLivrari/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Adrese livrare"
  },

  {
    exact: false,
    path: "/admin/company/delivery/form",
    component: myLazy(() =>
      import("../views/admin/deliveryFormPage/deliveryFormPage")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Formular adresă livrare"
  },
  //===================================================================
  // delivery location
  {
    exact: true,
    path: "/admin/company/towns/list",
    component: myLazy(() =>
      import("../views/admin/deliveryLocation/deliveryLocationList")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Localități"
  },

  {
    exact: false,
    path: "/admin/company/towns/form",
    component: myLazy(() =>
      import("../views/admin/deliveryLocation/deliveryLocationForm")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Formular localitate"
  },
  //===================================================================
  // account requests
  {
    exact: true,
    path: "/admin/company/accountrequests/list",
    component: myLazy(() => import("../views/admin/accountRequests/List")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Solicitări - cont Uniprest Instal"
  },
  {
    exact: false,
    path: "/admin/company/accountrequests/form",
    component: myLazy(() =>
      import("../views/admin/accountRequests/accountRequestForm")
    ), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Formular solicitare cont"
  },
  //===================================================================
  {
    exact: true,
    path: "/admin/company/dashboard",
    component: myLazy(() => import("../views/admin/unifiedDashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.ACCOUNT,
    pageTitle: "Organizații"
  },
  {
    exact: false,
    path: "/admin/company",
    component: () => <Redirect to="/admin/company/dashboard" />
  }
]
